/**
 * Placeholder shown while a lazily-loaded module page is still being fetched,
 * or while a stale-build reload is in progress.
 */
export function RouteFallback() {
  return (
    <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
      Carregando…
    </div>
  )
}
